import { useInjectReducer } from 'redux-injectors';
export default function useInjectedReducers(reducers) {
    if (reducers) {
        reducers.forEach((red) => {
            useInjectReducer({ key: red.key, reducer: red.reducer });
        });
    }
}
//# sourceMappingURL=useInjectedReducers.js.map